import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

export class CheckUserChartNameExistsUseCase implements UseCase<string, Promise<Result<boolean>>> {
  // Duplicidade de arquivo se dá pelo `originalFileName`; nome de exibição é validado em outro fluxo.
  private repository: IUserChartRepository

  constructor(repository?: IUserChartRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IUserChartRepository>(InjectionTokens.UserChartRepository)
  }

  async execute(originalFileName: string): Promise<Result<boolean>> {
    try {
      return await this.repository.existsByName(originalFileName)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
